import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { TermsRecordsList } from './components/TermsRecordsList';
import { TotadminPermission } from 'data/__generated__';

export const TermsRecords = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.termsRecords} />
                </HeaderTitle>
                <Link to={PAGES.termsRecordCreate.url}>
                    <TotemPrimaryButton requiredPermissions={[TotadminPermission.TermsRecordsManage]}>
                        Cr\u00e9er de nouvelles CGV
                    </TotemPrimaryButton>
                </Link>
            </Header>
            <Content>
                <ListContainer>
                    <TermsRecordsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
